
import React, {useRef, useEffect} from "react";
import {useAsyncSetState} from "use-async-setstate";
import Formsy from "formsy-react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {fetch} from "window-or-global";
import fetchin from "../logic/utils/fetch";
import Manager from "../components/manager";
import Theme from "../components/theme";
import Button from "../components/bootstrap/button";
import FormsyTextField from "../components/formsy/text-field";
import config from "../config";
import Terms from "../components/subcomponents/tnc";

const str = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
export function generatePassword(s = str, len = 8) {
  let r = "";
  for (let i = 0; i < len; i++) {
    const idx = Math.round(getRandomArbitrary(0, s.length - 1));
    r += s[idx];
  }
  return r;
}


export default function LoginPage() {
  const [errorMessage, setErrorMessage] = useAsyncSetState(null);
  const [checked, setCheck] = useAsyncSetState(false);
  const [showTerm, setTerm] = useAsyncSetState(false);
  const [loading, setLoadingAsync] = useAsyncSetState(false);
  const authFormEl = useRef(null);
  const [creds, setCreds] = useAsyncSetState({
    username: "",
    password: generatePassword(),
    dst: ""
  });
  
  async function checkIfLoggedInOnHotspot() {
    try {
      const text = await fetchin.get(config.loginStatus);
      console.log("data", text);
      const data = JSON.parse(text);
      if (data) {
        if (data.loggedIn === "yes") {
          root.location = config.targetUrl;
        }
      }
    } catch(err) {
      console.log("unable to talk to the hotspot", err);
    }
  }
  
  async function handleValidSubmit(data) {
    try {
      await setLoadingAsync(true);
      const {residency, ...rest} = data;
      const response = await fetch(`${config.apiUrl}rest.api/register`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Object.assign({password: creds.password}, {
          ...data, 
        })),
      });
      switch(response.status) {
        case 503:
        case 401:
          await setErrorMessage(() => (<>
            {"An error has occurred"}
          </>));
        case 200:
          const result = await response.json();
          // console.log("results", results)
          const {userName} = result;

          setCreds({...creds, userName});
          authFormEl.current.submit();
          // submit
      }
    } catch (err) {
      console.log("err", err);
      setErrorMessage("An error has occurred");
    }
  }
  
  
  useEffect(() => {
    checkIfLoggedInOnHotspot();
  }, []);

  return (
    <Manager name="login" title="Register">
      <Theme>
        <form ref={authFormEl} action={config.authUrl} method="post">
          <input type="hidden" name="username" value={creds.userName} />
          <input type="hidden" name="password" value={creds.password} />
          <input type="hidden" name="dst" value={creds.dst || config.targetUrl} />
        </form>
        <Formsy onValidSubmit={(data) => handleValidSubmit(data)}>
          <Container fluid className="form-spacer no-gutters">
            <Row className="field-row">
              <Col>
                <FormsyTextField
                  className="firstname-field"
                  name={"firstName"}
                  placeholder="First Name"
                  required
                />
              </Col>
            </Row>

            <Row className="field-row">
              <Col>
                <FormsyTextField
                  className="lastname-field"
                  name={"lastName"}
                  placeholder={"Last Name"}
                  required
                />
              </Col>
            </Row>
            <Row className="field-row">
              <Col>
                <FormsyTextField
                  name={"email"}
                  className="email-field"
                  placeholder={"Email Address"}
                  validations={"isEmail"}
                  validationError="A valid email address is required"
                  required
                />
              </Col>
            </Row>
            <Row className="field-row">
              <Col>
                {showTerm && <Terms onClose={() => setTerm(false)} />}
                <div className="vw-checkbox">
                  <i
                    onClick={async () => setCheck(!checked)}
                    className={`square-check-box ${
                      checked ? "far fa-check-square" : "far fa-square"
                    }`}
                  />
                  {"I agree to the"}
                  <a onClick={() => setTerm(true)} className="terms-link">
                    {"terms of use"}
                  </a>
                  {" of this network."}
                </div>
              </Col>
            </Row>
            <Row className="action-button-row">
            {errorMessage ? (
              <Col>
                <div className="alert alert-danger">
                  <i
                    className="fas fa-exclamation-circle"
                  />
                  {errorMessage}
                </div>
              </Col>
              ) : (
              <Col>
                <Button
                  type={"submit"}
                  className="continue-login-btn"
                  disabled={!checked}
                >
                  {"Continue"}
                </Button>
              </Col>
            )}
            </Row>
          </Container>
        </Formsy>
      </Theme>
    </Manager>
  );
}
